import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.object.to-string.js";
//是否为二维数组判断
function isValid2DArrayWithMinPoints(data) {
  // 首先判断是否为数组
  if (!Array.isArray(data)) {
    return false;
  }
  // 检查每个元素是否为数组（即是否为二维数组）
  return data.every(function (item) {
    return Array.isArray(item);
  });
}
export { isValid2DArrayWithMinPoints };